import PropTypes from 'prop-types';

function IFOurBrandsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47776)">
                <path
                    d="M12.9499 1.05336L3.43278 9.74974C2.88665 10.2488 2.84847 11.096 3.34751 11.6422L15.6989 25.1591C16.1979 25.7053 17.0452 25.7435 17.5913 25.2444L27.1084 16.548C27.6545 16.049 27.6927 15.2017 27.1936 14.6556L14.8423 1.13863C14.3433 0.592501 13.496 0.554323 12.9499 1.05336Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.8798 1.36472L9.75993 5.75922C9.06444 6.01139 8.70507 6.77962 8.95724 7.47511L15.1987 24.6887C15.4509 25.3842 16.2191 25.7436 16.9146 25.4914L29.0344 21.0969C29.7299 20.8447 30.0893 20.0765 29.8371 19.381L23.5956 2.16741C23.3435 1.47192 22.5752 1.11255 21.8798 1.36472Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M30.776 5.32027L17.913 4.4569C17.1749 4.40735 16.5363 4.96556 16.4868 5.70369L15.2605 23.9728C15.211 24.7109 15.7692 25.3495 16.5073 25.399L29.3703 26.2624C30.1084 26.3119 30.747 25.7537 30.7965 25.0156L32.0228 6.74649C32.0723 6.00836 31.5141 5.36982 30.776 5.32027Z"
                    fill="white"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.6038 13.2184C23.3309 12.8605 22.9836 12.1376 21.9241 12.2332C20.8681 12.3254 19.9184 13.2751 19.9857 14.4658C20.053 15.66 20.7051 16.7266 21.5697 17.5311C22.4344 18.3355 23.0722 18.7146 23.3628 18.8032C23.664 18.7288 25.3367 17.9138 26.0737 16.9995C26.8144 16.0817 27.5656 15.3517 27.1156 13.7216C26.6655 12.0915 24.7271 12.414 24.4862 12.6266C24.2452 12.8392 23.6038 13.2149 23.6038 13.2149V13.2184Z"
                    fill="#E95CA2"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47776">
                    <rect width="35.4794" height="29.5224" fill="white" transform="translate(0.399719 0.351562)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFOurBrandsActive;

IFOurBrandsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFOurBrandsActive.defaultProps = {
    className: null,
};
